module.exports = __webpack_public_path__ + "static/media/drag_reorder.992c8f5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/swipe/drag_reorder.jpg
// module id = 261
// module chunks = 0